import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=58989f24&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&lang=ts&"
export * from "./UserSelect.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=58989f24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58989f24",
  null
  
)

export default component.exports